export const CHAT_STICK_THRESHOLD_PX = 48;

export type ChatScrollMetrics = {
  readonly scrollTop: number;
  readonly clientHeight: number;
  readonly scrollHeight: number;
};

export function isChatStuckToBottom(metrics: ChatScrollMetrics): boolean {
  return metrics.scrollTop + metrics.clientHeight >= metrics.scrollHeight - CHAT_STICK_THRESHOLD_PX;
}

export function chatFollowScrollTop(
  scrollHeight: number,
  stickToBottom: boolean
): number | undefined {
  if (!stickToBottom) {
    return undefined;
  }
  return scrollHeight;
}
